import { getPriceValue } from 'src/modules/checkout/getPriceValue.ts';
import { AttributesClass } from 'src/generated/operations.ts';
import { UserSettings } from 'src/types/UserSettings.ts';

export type Accessory<T> = {
    accessory: T;
    qty: number;
    price: number;
}

export const prepareAccessories = <T extends { item: AttributesClass }>(
    accessories: T[],
    selectedAccessories: {
        label: string;
        qty: number;
    }[],
    userSettings: UserSettings,
    currency: string | null,
    compareFunction: (a: Accessory<T>, b: Accessory<T>) => number,
): Accessory<T>[] => accessories.reduce((acc, curr) => {
    const exist = acc.find((item) => item.accessory.item.Label === curr.item.Label);
    if (!exist && selectedAccessories.find(({ label }) => label === curr.item.Label) !== undefined) {
        const accessoryItem = selectedAccessories.find(({ label }) => label === curr.item.Label);
        const qty = accessoryItem ? accessoryItem.qty : 1;
        const price = getPriceValue(
            curr.item,
            userSettings.shoppingCenter as keyof typeof curr.item,
            currency,
        );
        acc.push({
            accessory: curr,
            qty,
            price: price?.value || 0,
        });
    }
    return acc;
}, [] as Accessory<T>[])
    .sort(compareFunction);
